import React, { useEffect, useRef } from 'react';

const Skills = () => {
  const skillsRef = useRef(null);
  
  useEffect(() => {
    const currentRef = skillsRef.current;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const skillCards = entry.target.querySelectorAll('.skill-card');
          skillCards.forEach((card, index) => {
            setTimeout(() => {
              card.classList.add('animate-fadeInUp');
            }, index * 150);
          });
          
          const cert = entry.target.querySelector('.certification');
          if (cert) {
            setTimeout(() => {
              cert.classList.add('animate-fadeInUp');
            }, 600);
          }
        }
      });
    }, { threshold: 0.1 });
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const skillCategories = [
    {
      name: 'Frontend',
      skills: [
        'React.js', 'Next.js', 'Angular 10+', 'Redux', 
        'JavaScript (ES6+)', 'TypeScript', 'HTML5', 
        'CSS3', 'Tailwind CSS', 'Bootstrap 5'
      ]
    },
    {
      name: 'Backend',
      skills: [
        'Java 8/11/17', 'Spring Boot', 'Spring Cloud', 'Hibernate (JPA)','Spring Security','Microservices','Node.js', 'Express.js',  
        'Python', 'RESTful APIs'
      ]
    },
    {
      name: 'Cloud & DevOps',
      skills: [
        'AWS (EC2, RDS, S3, Lambda, SNS, SQS)','Azure (VMs, Blob Storage, SQL Database, DevOps Pipelines)','Docker','Kubernetes','Terraform','Jenkins','Git'
      ]
    },
    {
      name: 'Databases',
      skills: [
        'MongoDB', 'PostgreSQL', 'MySQL', 'Firebase', 
        'DynamoDB'
      ]
    }
  ];

  return (
    <section id="skills" ref={skillsRef} className="py-20 bg-white/95 dark:bg-gray-900/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 opacity-1 transform translate-y-10">
          <h2 className="text-3xl md:text-4xl font-bold text-black dark:text-white">Technical Skills</h2>
          <p className="mt-4 text-xl text-black dark:text-gray-400 max-w-3xl mx-auto font-bold">
            Expertise across the full stack with focus on performance, scalability, and user experience
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skillCategories.map((category) => (
            <div 
              key={category.name} 
              className="skill-card opacity-0 transform translate-y-10 bg-white dark:bg-gray-900 rounded-xl shadow-lg p-6 border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-shadow"
            >
              <h3 className="text-xl font-bold mb-4 text-indigo-600 dark:text-indigo-400">
                {category.name}
              </h3>
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill) => (
                  <span 
                    key={skill} 
                    className="px-3 py-1 bg-indigo-100 dark:bg-indigo-900/50 text-indigo-800 dark:text-indigo-200 rounded-full text-sm font-bold"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 certification opacity-0 transform translate-y-10 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl p-8 text-white">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div>
              <h3 className="text-2xl font-bold">AWS Certified Solutions Architect</h3>
              <p className="mt-2 max-w-xl">
                Validated expertise in designing distributed systems on AWS.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-bold">Oracle Certified Professional: Java SE 17 Developer</h3>
              <p className="mt-2 max-w-xl">
                Proven skill in modern Java application development.
              </p>
            </div>
            {/* <div className="mt-6 md:mt-0">
              <div className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-bold inline-block">
                Credential ID: 0569fbf6ad7748d98dc165b4860bbdc2
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;